import { CategoryChartVisibilityFn } from "../categoryChart";
import { getCountPerLocationKpisForProviders } from "../opendata";

export const doPerConnectionKpisForTheProvidersExist: CategoryChartVisibilityFn = async ({
    categoryChart,
    locationAdminIds,
    kpis = []
}) => {
    const count = await getCountPerLocationKpisForProviders(categoryChart?.category, kpis, locationAdminIds);
    return count > 0;
};
